<script setup>

</script>

<template>
    <div id="footer" class="uk-background-primary uk-flex uk-flex-center uk-width-1-1">
        <div><span class="uk-margin-small-right" style="font-size: 1.2em;">©</span>
            <span style="vertical-align: text-bottom; font-size: 0.8em;">COLOPL, Inc.</span></div>
    </div>
</template>

<style scoped>
    #footer {
        height: var(--footer-height);
        background: var(--common-background);
        align-items: center;
        color: var(--text-color-white);
        > div {
            font-family: Comfortaa, sans-serif, cursive;
        }
    }
</style>